<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>
<ion-content [fullscreen]="true">
  <ion-title class="smaller">
    <h1>Rediger kontaktinfo</h1>
  </ion-title>

  <app-editcontact [canChangeAddress]="canChangeAddress"></app-editcontact>
</ion-content>
